import { RootState } from '@reducers';

export const selectInsuranceClaimEditModalReducer = (state: RootState) => state.userDashboardRouteReducer.insuranceClaimEditModalReducer;
